import { Button, UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export const ExaminationsHeadingTooltip = () => {
  const { t } = useTranslation();
  return (
    <>
      {' '}
      <Button
        id={'examinationsInfoButton'}
        size="lg"
        color="none"
        className="position-absolute heading-tooltip border-0"
      >
        <i className="fa fa-question-circle text-muted"></i>
      </Button>
      <UncontrolledTooltip
        target={'examinationsInfoButton'}
        placement="bottom-start"
        container="body"
        delay={{ show: 50, hide: 50 }}
        style={{
          minWidth: '300px',
          backgroundColor: 'var(--balance-profie-bg)',
        }}
      >
        <div className="d-flex flex-column text-start">
          <p className="p-0 m-0">
            <span className="f-w-700">{t('leads.examinations.unset')}:</span>{' '}
            {t('leads.examinations.tooltip.unsetDescr')}
          </p>
          <p className="p-0 mb-0 mt-2">
            <span className="f-w-700">{t('leads.examinations.future')}:</span>{' '}
            {t('leads.examinations.tooltip.futureDescr')}
          </p>
          <p className="p-0 mb-0 mt-2">
            <span className="f-w-700">{t('leads.examinations.past')}:</span>{' '}
            {t('leads.examinations.tooltip.pastDescr')}
          </p>
        </div>
      </UncontrolledTooltip>
    </>
  );
};
